import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useMappedState } from "redux-react-hook";
import { Link, Redirect } from "react-router-dom";
import {
  TextInput,
  Button,
  SelectOption,
  Form,
  FormGroup,
  ActionGroup,
  Alert,
} from "@patternfly/react-core";
import { Spinner } from '@patternfly/react-core';
import {
  REQUESTED_PRODUCT_SUITES,
  REQUESTED_CREATE_PRODUCT_SUITE,
  REQUESTED_UPDATE_PRODUCT_SUITE,
} from "../../redux/actions/productSuiteAction";
import { REQUESTED_PRODUCTS } from "../../redux/actions/productAction";
// import { REQUESTED_ACTIVITIES } from "../../redux/actions/activityAction";
import MultiTypeaheadSelectInput from "../general/MultipleSelect";

export default (props) => {
  const mapState = useCallback(
    (state) => ({
      productsMap: state.productState.productsMap,
      isFetchingProducts: state.productState.isFetchingProducts,
      isCreatingProductSuite: state.productSuiteState.isCreatingProductSuite,
      isCreatedProductSuite: state.productSuiteState.isCreatedProductSuite,
      isUpdatingProductSuite: state.productSuiteState.isUpdatingProductSuite,
      isUpdatedProductSuite: state.productSuiteState.isUpdatedProductSuite,
    }),
    []
  );

  const {
    productsMap,
    isFetchingProducts,
    isCreatingProductSuite,
    isCreatedProductSuite,
    isUpdatingProductSuite,
    isUpdatedProductSuite,
  } = useMappedState(mapState);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!productsMap) {
      dispatch({
        type: REQUESTED_PRODUCTS,
        payload: {},
      });
    }
  }, [dispatch, productsMap]);

  const productOptions =
    productsMap && !isFetchingProducts
      ? Object.keys(productsMap).map((key) => ({
          id: productsMap[key].id,
          value: key,
          disabled: false,
        }))
      : [];

  const productSelectOptions = productOptions.map((option, index) => (
    <SelectOption
      isDisabled={option.disabled}
      key={`product-${index}`}
      value={option.value}
    />
  ));

  const [productSuiteName, setProductSuiteName] = useState(
    props.productSuite ? props.productSuite.name : ""
  );
  const [productSuiteLink, setProductSuiteLink] = useState(
    props.productSuite ? props.productSuite.link : ""
  );
  const [productSuiteAcronyms, setProductSuiteAcronyms] = useState(
    props.productSuite ? props.productSuite.acronyms : ""
  );
  const [productSuiteUpserted, setProductSuiteUpserted] = useState(false);
  const [editProducts, setEditProducts] = useState();
  const [errorMsg, setErrorMsg] = useState("");

  let selectedProducts = [];
  if (props.productSuite && props.productSuite.products) {
    props.productSuite.products.forEach((product) => {
      selectedProducts.push(product.name);
    });
  }

  function onSubmit(is_draft) {
    if (props.productSuite) {
      //console.log('---------updating-a-productSuite---------');
      let updatedata = {
        id: props.productSuite.id,
        productSuite: !!is_draft ? { is_draft: is_draft } : {},
      };
      if (productSuiteName && productSuiteName !== props.productSuite.name) {
        updatedata.productSuite.name =
          productSuiteName === "" ? null : productSuiteName;
      }
      if (
        productSuiteAcronyms &&
        productSuiteAcronyms !== props.productSuite.acronyms
      ) {
        updatedata.productSuite.acronyms =
          productSuiteAcronyms === "" ? null : productSuiteAcronyms;
      }
      if (productSuiteLink && productSuiteLink !== props.productSuite.link) {
        updatedata.productSuite.link =
          productSuiteLink === "" ? null : productSuiteLink;
      }

      if (editProducts) {
        let add_products = [];
        let delete_products = [];
        editProducts.forEach((editproduct) => {
          if (!selectedProducts.includes(editproduct)) {
            add_products.push(editproduct);
          }
        });

        selectedProducts.forEach((selectproduct) => {
          if (!editProducts.includes(selectproduct)) {
            delete_products.push(selectproduct);
          }
        });
        if (add_products && add_products.length !== 0) {
          updatedata.productSuite.add_products = add_products;
        }
        if (delete_products && delete_products.length !== 0) {
          updatedata.productSuite.delete_products = delete_products;
        }
      }
      //console.log(updatedata);
      if (productSuiteName.trim() === "") {
        setErrorMsg("Product Suite Name cannot be empty");
      } else if (editProducts && editProducts.length === 0) {
        setErrorMsg("Product Suite must contain at least one product");
      } else {
        if (Object.keys(updatedata.productSuite).length > 0) {
          dispatch({
            type: REQUESTED_UPDATE_PRODUCT_SUITE,
            payload: { productSuite: updatedata },
          });
        }
      }
    } else {
      //console.log('---------creating-a-productSuite---------');
      let createdata = {
        name: productSuiteName,
        acronyms: productSuiteAcronyms,
        link: productSuiteLink,
        is_draft: is_draft,
      };

      if (editProducts && editProducts.length !== 0) {
        createdata = { ...createdata, add_products: editProducts };
      }
      //console.log(createdata);
      if (productSuiteName.trim() === "") {
        setErrorMsg("Product Suite Name cannot be empty");
      } else if (!editProducts || editProducts.length === 0) {
        setErrorMsg("Product Suite must contain at least one product");
      } else {
        dispatch({
          type: REQUESTED_CREATE_PRODUCT_SUITE,
          payload: { productSuite: createdata },
        });
      }
    }
  }

  function renderButtons() {
    if (isCreatingProductSuite || isUpdatingProductSuite) {
      return <Spinner size="xl" />;
    }
    return (
      <>
        {!props.productSuite && (
          <Button
            variant="primary"
            onClick={() => onSubmit(true)}
          >{`Save as Draft`}</Button>
        )}
        {!props.productSuite && (
          <Button
            variant="secondary"
            onClick={() => onSubmit(false)}
          >{`Save & publish`}</Button>
        )}
        {props.productSuite && (
          <Button variant="primary" onClick={() => onSubmit()}>{`Save`}</Button>
        )}
        <Link to="/product/suite">
          <Button
            variant="tertiary"
            disabled={isCreatingProductSuite || isUpdatingProductSuite}
          >{`Cancel`}</Button>
        </Link>
      </>
    );
  }

  useEffect(() => {
    if (isCreatedProductSuite || isUpdatedProductSuite) {
      dispatch({
        type: REQUESTED_PRODUCT_SUITES,
        payload: {},
      });
      setProductSuiteUpserted(true);
      // dispatch({
      //   type: REQUESTED_ACTIVITIES,
      //   payload: {},
      // });
    }
  }, [dispatch, isCreatedProductSuite, isUpdatedProductSuite]);

  function onSelectProduct(selected) {
    setEditProducts(selected);
  }

  function renderErrorMsg() {
    if (errorMsg !== "") {
      return <Alert variant="danger" title={`${errorMsg}`} />;
    }
  }

  return (
    <>
      {productSuiteUpserted ? <Redirect to="/product/suite" /> : null}
      <Form>
        <FormGroup
          label="Name"
          isRequired
          fieldId="product-suite-create-form-name"
        >
          <TextInput
            value={productSuiteName}
            isRequired
            type="text"
            id="product-suite-create-form-name"
            aria-describedby="product-suite-create-form-name-helper"
            name="product-suite-create-form-name"
            onChange={(value) => {
              setProductSuiteName(value);
            }}
          />
        </FormGroup>
        <FormGroup label="Product" fieldId="product-suite-create-form-member">
          <MultiTypeaheadSelectInput
            titleId="member-multi-select"
            placeholder="Select Product"
            options={productSelectOptions}
            selected={selectedProducts}
            onSelect={(selected) => onSelectProduct(selected)}
          />
        </FormGroup>
        <FormGroup
          label="Acronyms, Short Names, Key Components"
          fieldId="product-suite-create-form-acronyms"
        >
          <TextInput
            value={productSuiteAcronyms}
            onChange={(value) => {
              setProductSuiteAcronyms(value);
            }}
            type="text"
            id="product-suite-create-form-acronyms"
            name="product-suite-create-form-acronyms"
          />
        </FormGroup>
        <FormGroup label="Link" fieldId="product-suite-create-form-link">
          <TextInput
            value={productSuiteLink}
            onChange={(value) => {
              setProductSuiteLink(value);
            }}
            type="url"
            id="product-suite-create-form-link"
            name="product-suite-create-form-link"
          />
        </FormGroup>
        {renderErrorMsg()}
        <ActionGroup>{renderButtons()}</ActionGroup>
      </Form>
    </>
  );
};
